export default __webpack_public_path__ + "static/media/striding-feather-nam.a6fb8aac.jpg";